// extracted by mini-css-extract-plugin
export default {"root":"Format_root__VIV0q","grad":"Format_grad__fY+sK","grad_active":"Format_grad_active__Qxo+l","far":"Format_far__ux-n+","far_active":"Format_far_active__rl7b5"};